export default "__VITE_ASSET__y7UmIC61__"